import { useEffect } from 'react';
import toast from 'react-hot-toast';

export default function RedHotToast({
	type = 'success',
	message = 'Operation completed!',
	position = 'top-right',
	dismissable = false,
	toastId,
	trigger,
}) {
	useEffect(() => {
		let toastFn = toast.success;
		if (type === 'error') toastFn = toast.error;
		if (type === 'loading') toastFn = toast.loading;

		const isLoading = type === 'loading';

		const options = {
			position,
			duration: isLoading || dismissable ? Infinity : 4000,
			...(toastId ? { id: toastId } : {}),
		};

		if (!toastId) {
			toast.dismiss();
		}

		if (dismissable && !isLoading) {
			toastFn(
				(t) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<span>{message}</span>
						<button
							onClick={() => toast.dismiss(t.id)}
							style={{
								background: 'transparent',
								border: 'none',
								fontSize: '16px',
								color: 'inherit',
								cursor: 'pointer',
							}}
						>
							×
						</button>
					</div>
				),
				options
			);
		} else {
			toastFn(message, options);
		}
	}, [type, message, position, dismissable, toastId, trigger]); // 👈 trigger here

	return null;
}
